import api from './api/api';

class MailTemplateService {
  getLogin() {
    return api.get('/admin/mailtemplate/login/');
  }

  updateLogin(data) {
    return api.post('/admin/mailtemplate/login/', data);
  }

  testLogin(data) {
    return api.post('/admin/mailtemplate/login/test/', data);
  }
}

export default new MailTemplateService();
